// extracted by mini-css-extract-plugin
export default {"explanerButton":"szhCmp36bMAY7Qa1ODM5","content":"E9b4QhTwyxtNKA_UBMZN","heading":"eheoDSe9GsnEHAQw0sui","infoCircle":"q9JW3b8M3SXeOXFUONYD","list":"esuGsrNVS84G9IrrQxVP"};